import showCropSeasonMismatchModal from 'helpers/showCropSeasonMismatchModal';
import { hasCropSeasonMismatch } from 'helpers/cropSeasonMismatch';
import useSelectedCropSeasonIds from 'hooks/useSelectedCropSeasonIds';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import { RecordSourceType } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { Plan } from '../ConvertPlanModalV2/types';

const usePlanToOperationAction = () => {
  const { selectedCropSeasonIds } = useSelectedCropSeasonIds();

  const handleConvertPlanToOperationAction = (
    currentPlan: Plan,
    operationType: OperationType,
    recordSourceType: RecordSourceType.RECOMMENDATION | RecordSourceType.PLANS,
    callback: () => void
  ) => {
    const uniqueCropSeasonIds = [
      ...new Set(currentPlan.cropZones.map(cropZone => cropZone.cropSeasonId))
    ];
    const hasMismatch = hasCropSeasonMismatch({
      sourceGroupCount: currentPlan.cropZones.length,
      sourceCropSeasonIds: uniqueCropSeasonIds,
      selectedCropSeasonIds
    });

    if (hasMismatch) {
      showCropSeasonMismatchModal(callback, operationType, recordSourceType);
    } else {
      callback();
    }
  };

  return {
    handleConvertPlanToOperationAction
  };
};

export default usePlanToOperationAction;
